import React from "react";

const Cheque = () => {
  return (
    <div
      className="container-fluid d-flex justify-content-center align-items-center"
      style={{ minHeight: "80vh" }}
    >
      <div className="text-center">
        {/* <img
          src="https://media.giphy.com/media/3o7TKtnuHOHHUjR38Y/giphy.gif"
          alt="Coming Soon"
          style={{
            width: "250px",
            maxWidth: "100%",
          }}
        /> */}

        <img
  src="https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif"
  alt="Coming Soon"
  width="250"
/>

        <h2 className="mt-4 fw-bold text-primary">
          Cheque Module Coming Soon
        </h2>

        <p className="text-muted fs-5">
          We're working hard to bring this feature to you.
        </p>
      </div>
    </div>
  );
};

export default Cheque;
